import { render, staticRenderFns } from "./AlumnoVerProfesor.vue?vue&type=template&id=b474bf86&"
import script from "./AlumnoVerProfesor.vue?vue&type=script&lang=js&"
export * from "./AlumnoVerProfesor.vue?vue&type=script&lang=js&"
import style0 from "./AlumnoVerProfesor.vue?vue&type=style&index=0&id=b474bf86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports